<script lang="ts" setup>
import { SpaceBetweenSwiper } from '~/enums'
import { usePartnerProvider } from '~/composables/common/use-partner-providers'
import { useSwiper } from '~/composables/common/use-swiper'
const { modules, SwiperSlide, Swiper } = useSwiper()
const { logoPartners } = usePartnerProvider()
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean
</script>

<template>
  <div v-if="!$isLighthouseBot" class="providers">
    <div class="providers__bg">
      <img src="/images/providers/rectangle-bg.webp" alt="bg" loading="lazy" />
    </div>
    <div class="providers__title">
      <div class="providers__title-img">
        <img
          src="/images/providers/icon-trust-contact.webp"
          alt="icon trust contact"
          width="52"
          height="52"
          loading="lazy"
        />
      </div>
      <div class="providers__title-text">Đối tác đáng tin cậy</div>
    </div>
    <div class="providers__line" />
    <div class="providers__list">
      <Swiper
        v-if="logoPartners?.length"
        :modules="modules"
        :slides-per-view="9.5"
        :slides-per-group="1"
        :space-between="SpaceBetweenSwiper.XxlLarger"
        lazy
        :autoplay="
          $isLighthouseBot
            ? false
            : {
                delay: 1,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                reverseDirection: true
              }
        "
        :speed="3000"
        :loop="!$isLighthouseBot"
        :breakpoints="{
          1400: {
            spaceBetween: SpaceBetweenSwiper.Large,
            slidesPerView: 7.5,
          },
          1500: {
            spaceBetween: SpaceBetweenSwiper.xlLarger,
            slidesPerView: 9.5,
          },
        }"
      >
        <SwiperSlide
          v-for="(item, index) in logoPartners"
          :key="`${item.title}_${index}`"
          class="providers__item"
        >
          <a
            v-if="item.link"
            :href="item.link"
            class="providers__link"
            target="_blank"
            rel="nofollow"
          >
            <img
              :src="item.logo"
              :alt="item.title"
              class="providers__logo"
              loading="lazy"
            />
          </a>
          <img
            v-else
            :src="item.logo"
            :alt="item.title"
            class="providers__list--logo"
            loading="lazy"
          />
        </SwiperSlide>
      </Swiper>
    </div>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/providers.scss';
</style>
